import { render, staticRenderFns } from "./Boilerplate.vue?vue&type=template&id=2aaa0ce8&"
import script from "./Boilerplate.vue?vue&type=script&lang=js&"
export * from "./Boilerplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports